<!--
 * @Author: xwc
 * @Date: 2020-07-29 10:39:26
 * @LastEditors: fyx
 * @LastEditTime: 2022-02-15 14:06:56
 * @FilePath: \jdy\src\App.vue
-->
<template>
  <div id="app">
    <div class="slide">
      <el-carousel height="700px" :interval="3000">
        <el-carousel-item v-for="item in banners" :key="item" >
          <el-image style="width: 100%; height: 100%;" :src="item"></el-image>
        </el-carousel-item>
      </el-carousel>
      <div class="title">
        <img :src="require('@/assets/logo.png')" class="sidebar-logo" />
        <span class="left-title">佳登云</span>
        <span class="right-title space">|</span>
        <span class="right-title">灵活用工智能结算平台</span>
      </div>
      <div class="button">
        <el-button class="login" @click="login" type="text">登录</el-button>
        <el-button class="register" @click="register" type="primary">注册</el-button>
      </div>
    </div>
    <div class="info-one">
      <div class="title">企业痛点</div>
      <div class="title-en">BUSINESS PAIN POINTS</div>
      <div class="more">
        <div class="item">
          <img class="img" :src="require('@/assets/info-1.png')" />
          <span class="text">社保入税</span>
          <span class="text">企业用工成本高</span>
        </div>
        <div class="line"></div>
        <div class="item">
          <img class="img" :src="require('@/assets/info-2.png')" />
          <span class="text">劳动纠纷</span>
          <span class="text">企业用工风险大</span>
        </div>
        <div class="line"></div>
        <div class="item">
          <img class="img" :src="require('@/assets/info-3.png')" />
          <span class="text">对私结算</span>
          <span class="text">企业取得发票困难</span>
        </div>
        <div class="line"></div>
        <div class="item">
          <img class="img" :src="require('@/assets/info-4.png')" />
          <span class="text">个税税负高</span>
          <span class="text">员工获得感差</span>
        </div>
      </div>
    </div>
    <div class="info-two">
      <div class="title">用工成本违规应对</div>
      <div class="title-en">LABOR COST VIOLATION</div>

      <div class="item">
        <img class="img" :src="require('@/assets/info-two-1.png')" />
        <div class="right">
          <div class="title">
            <span>违反税法</span>
          </div>
          <div class="info">
            <span>税法规定：“企业应扣未扣、应收而不收税款的，由税务机关向纳税人追缴税款，对扣缴义务人处应扣未扣、应收未收税款百分之五十以上三倍以下的罚款。</span>
          </div>
        </div>
      </div>

      <div class="item">
        <img class="img" :src="require('@/assets/info-two-2.png')" />
        <div class="right">
          <div class="title">
            <span>稽查风险高</span>
          </div>
          <div class="info">
            <span>个人税务风险意识差，如取得虚开的发票提供给企业使用，增加企业被税务稽查的风险。</span>
          </div>
        </div>
      </div>

      <div class="item">
        <img class="img" :src="require('@/assets/info-two-3.png')" />
        <div class="right">
          <div class="title">
            <span>触及刑法</span>
          </div>
          <div class="info">
            <span>虚开增值税发票罪：刑期下至三年以下有期徒刑上至无期徒刑，罚金最低两万以上最高可达五十万或者没收财产。</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="info-three"
      :style="{
        backgroundImage: 'url(' + require('@/assets/info-three-bg.png') + ')',
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
      }"
    >
      <div class="title">传统用工VS灵活用工</div>
      <div class="title-en">TRADITIONAL VERSUS FLEXIBLE LABOR</div>
      <div class="menu">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#545c6400"
          text-color="#FFF"
          active-text-color="#FFF"
        >
          <!-- <el-menu-item @mouseover.native="onThreemouse(1)" index="1">正式员工</el-menu-item> -->
          <el-menu-item @mouseover.native="onThreemouse(1)" index="1">非全日制员工</el-menu-item>
          <el-menu-item @mouseover.native="onThreemouse(2)" index="2">兼职</el-menu-item>
          <!-- <el-menu-item @mouseover.native="onThreemouse(4)" index="4">劳务派遣</el-menu-item> -->
          <!-- <el-menu-item @mouseover.native="onThreemouse(5)" index="5">业务众包</el-menu-item> -->
        </el-menu>
      </div>
      <div class="menu-img">
        <el-carousel
          height="360px"
          arrow="never"
          indicator-position="none"
          :autoplay="false"
          ref="menuCarousel"
        >
          <el-carousel-item v-for="item in menu" :key="item">
            <el-image style="width: 1020px;" :src="item"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- <div class="info-four">
      <div class="title">灵活用工解决方案</div>
      <div class="title-en">FLEXIBLE EMPLOYMENT SOLUTIONS</div>
      <img :src="require('@/assets/info-four-bg.png')" />
      <div class="title-2">
        <div class="diamond"></div>
        <span>灵活用工业务流程</span>
      </div>
      <img class="step" :src="require('@/assets/info-four-more.png')" />
    </div> -->
    <!-- <div class="info-five">
      <div class="title">应用场景</div>
      <div class="title-en">APPLICATION PACKAGE</div>
      <div class="button-menu">
        <el-menu
          :default-active="activeIndex2"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect2"
          background-color="#F5F7F9"
        >
          <el-menu-item @mouseover.native="onFourmouse(1)" index="1">平台经济应用场景</el-menu-item>
          <div style="margin-right:128px;"></div>
          <el-menu-item @mouseover.native="onFourmouse(2)" index="2">周期性灵活用工应用场景</el-menu-item>
        </el-menu>
      </div>
      <div class="selectImg">
        <img :src="require('@/assets/info-five-'+ selectItem +'.png')" />
      </div>
    </div> -->
    <div class="info-six">
      <div class="title">适用行业</div>
      <div class="title-en">ADVANTAGES OF ENTERPRISE PLATFORM</div>
      <div class="content">
        <img class="bg" :src="require('@/assets/info-six-bg.png')" />
        <div class="left-tab">
          <div class="menu">
            <el-menu :default-active="sexActive" @select="menuSelect" class="el-menu-vertical-demo">
              <el-menu-item @mouseover.native="onSixmouse(1)" index="1">
                <i :class="sexActive == '1' ?'line':'block'"></i>
                <span slot="title">生活服务</span>
              </el-menu-item>
              <el-menu-item @mouseover.native="onSixmouse(2)" index="2">
                <i :class="sexActive == '2' ?'line':'block'"></i>
                <span slot="title">营销推广</span>
              </el-menu-item>
              <el-menu-item @mouseover.native="onSixmouse(3)" index="3">
                <i :class="sexActive == '3' ?'line':'block'"></i>
                <span slot="title">文化传媒</span>
              </el-menu-item>
              <el-menu-item @mouseover.native="onSixmouse(4)" index="4">
                <i :class="sexActive == '4' ?'line':'block'"></i>
                <span slot="title">商业服务</span>
              </el-menu-item>
              <el-menu-item @mouseover.native="onSixmouse(5)" index="5">
                <i :class="sexActive == '5' ?'line':'block'"></i>
                <span slot="title">金融服务</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
        <div class="number">
          <span class="left">0{{sexActive}}</span>
          <span class="center">/</span>
          <span class="right">05</span>
        </div>
        <div class="right-img">
          <img :key="sexActive" :src="require('@/assets/info-six-'+ sexActive +'.png')" />
        </div>
        <div class="check">
          <img :src="require('@/assets/info-six-right.png')" @click="check(1)" />
          <img :src="require('@/assets/info-six-left.png')" @click="check(-1)" />
        </div>
      </div>
    </div>
    <div class="info-seven">
      <div class="title">不仅是SAAS系统 而是定制化开发</div>
      <div class="title-en">CUSTOM DEVELOPMENT SERVICES</div>
      <div class="content">
        <div class="item">
          <img class="top-img" :src="require('@/assets/info-seven-top-1.png')" />
          <span class="title">API标准接口</span>
          <span class="info">支持灵活用工公司对接触客户系统接口，实现客户订单数据与业务流批量场景化处理</span>
          <img class="bottom-img" :src="require('@/assets/info-seven-bottom-1.png')" />
        </div>
        <div class="none"></div>
        <div class="item">
          <img class="top-img" :src="require('@/assets/info-seven-top-2.png')" />
          <span class="title">功能定制化开发</span>
          <span class="info">功能模块高频迭代，可依据业务及市场需求迅速调整新增</span>
          <img class="bottom-img" :src="require('@/assets/info-seven-bottom-2.png')" />
        </div>
        <div class="none"></div>
        <div class="item">
          <img class="top-img" :src="require('@/assets/info-seven-top-3.png')" />
          <span class="title">安全高效结算</span>
          <span class="info">在合作银行配置资金专用共管账户，往来动态采用银行级安全机制，T+0实时结算</span>
          <img class="bottom-img" :src="require('@/assets/info-seven-bottom-3.png')" />
        </div>
      </div>
    </div>
    <div class="info-eight">
      <div class="title">佳登云优势</div>
      <div class="title-en">ADVANTAGES OF ENTERPRISE PLATFORM</div>
      <div class="content">
        <div v-if="eightClick == 1" class="item-back">
          <div class="top">
            <div class="title">加强税务合规</div>
            <div class="index">01</div>
          </div>
          <div
            class="center"
          >佳登云作为税务服务平台依法代征税费，企业通过撮合平台与自由职业者结算报酬，直接交易方由零散个人变成单一企业，避免企业直面多个个人而产生的一系列税务问题</div>
          <div class="bottom">
            <img class="bottom-img" :src="require('@/assets/info-eight-back.png')" />
          </div>
        </div>
        <div v-else class="item-front" @mouseover="infoEightMouse(1)" @click="rightClick(1)">
          <div class="top">
            <div class="title">加强税务合规</div>
            <div class="index">01</div>
          </div>
          <div class="bottom">
            <img class="bottom-img" :src="require('@/assets/info-eight-font.png')" />
          </div>
        </div>
        <div style="margin-right:26px;"></div>

        <div v-if="eightClick == 2" class="item-back">
          <div class="top">
            <div class="title">规避用工风险</div>
            <div class="index">02</div>
          </div>
          <div class="center">众包方案下，用工企业与自由职业者之间不再有直接业务关系，被认定为与自由职业者存在事实劳动关系的风险大大降低，达到了降低企业用工风险的目的</div>
          <div class="bottom">
            <img class="bottom-img" :src="require('@/assets/info-eight-back.png')" />
          </div>
        </div>
        <div v-else class="item-front" @mouseover="infoEightMouse(2)" @click="rightClick(2)">
          <div class="top">
            <div class="title">规避用工风险</div>
            <div class="index">02</div>
          </div>
          <div class="bottom">
            <img class="bottom-img" :src="require('@/assets/info-eight-font.png')" />
          </div>
        </div>
        <div style="margin-right:26px;"></div>

        <div v-if="eightClick == 3" class="item-back">
          <div class="top">
            <div class="title">降低用工成本</div>
            <div class="index">03</div>
          </div>
          <div class="center">企业采用结算云方案，支付的服务费包含所有用工成本，自由职业者直接取得税后收入，降低企业用工成本，提高个人税后收入</div>
          <div class="bottom">
            <img class="bottom-img" :src="require('@/assets/info-eight-back.png')" />
          </div>
        </div>
        <div v-else class="item-front" @mouseover="infoEightMouse(3)" @click="rightClick(3)">
          <div class="top">
            <div class="title">降低用工成本</div>
            <div class="index">03</div>
          </div>
          <div class="bottom">
            <img class="bottom-img" :src="require('@/assets/info-eight-font.png')" />
          </div>
        </div>
        <div style="margin-right:26px;"></div>
      </div>
    </div>
    <div class="info-nine">
      <div class="button">
        <img @click="login" class="top-img" :src="require('@/assets/info-nine.png')" />
      </div>
    </div>
    <div class="bottomTip" @click="goUrl()">Copyright © 2020 - 2030 All Rights Reserved 湖南佳登科技有限公司 版权所有 湘ICP备2020021809号-1</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        require("@/assets/banner_1.png"),
        require("@/assets/banner_2.png"),
      ],
      menu: [
        require("@/assets/menu-1.png"),
        require("@/assets/menu-2.png"),
        require("@/assets/menu-3.png"),
        require("@/assets/menu-4.png"),
        require("@/assets/menu-5.png"),
      ],
      activeIndex: "1",
      activeIndex2: "1",
      selectItem: "1",
      sexActive: "1",
      eightClick: 1,
    };
  },
  methods: {
    login() {
      window.open("https://www.jiadengyun.com/operator/#/login");
    },
    register() {
      window.open("https://www.jiadengyun.com/operator/#/login?state=1");
    },
    handleSelect(key) {
      this.$refs.menuCarousel.setActiveItem(key - 1);
    },
    onThreemouse(key) {
      this.activeIndex = key.toString();
      this.$refs.menuCarousel.setActiveItem(key - 1);
    },
    handleSelect2(key) {
      this.selectItem = key;
    },
    onFourmouse(key) {
      this.activeIndex2 = key;
      this.selectItem = key;
    },
    menuSelect(index) {
      this.sexActive = index;
    },
    onSixmouse(index) {
      this.sexActive = index.toString();
    },
    check(index) {
      this.sexActive = parseInt(this.sexActive) + index + "";
      if (parseInt(this.sexActive) <= 0) this.sexActive = 1 + "";
      if (parseInt(this.sexActive) > 5) this.sexActive = 5 + "";
    },
    rightClick(index) {
      this.eightClick = index;
    },
    infoEightMouse(index) {
      this.eightClick = index;
    },

    //跳转
    goUrl() {
      window.open("https://beian.miit.gov.cn/", "_blank");
    }
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  background-color: white;
}
.slide {
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__indicators--horizontal {
    bottom: 2%;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #ffffff;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #ffffff;
  }
  .title {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10000;
    display: flex;
    flex-direction: row;
    padding-left: 34px;
    padding-top: 14px;
    img {
      width: 32px;
      height: 32px;
      align-self: center;
    }
    .left-title {
      font-size: 24px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      color: #ffffff;
      line-height: 36px;
      margin-left: 14px;
      margin-right: 16px;
    }
    .space {
      margin-right: 15px;
    }
    .right-title {
      font-size: 24px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      color: #ffffff;
      line-height: 36px;
      font-weight: 100;
    }
  }

  .button {
    position: absolute;
    right: 2%;
    top: 14px;
    z-index: 10000;
    display: flex;
    flex-direction: row;
    .login {
      color: #fff;
      margin-right: 10px;
    }
    .register {
      border-radius: 0px;
    }
  }
  .goto {
    position: absolute;
    left: 320px;
    top: 478px;
    // left: 16.5%;
    // top: 65%;
    z-index: 10000;
    width: 174px;
    height: 45px;
    background: #ffffff;
    border-radius: 6px;
    font-size: 20px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #100549;
  }
}
.info-one {
  width: 100%;
  height: 770px;
  background: -moz-linear-gradient(top, #ffffff 0%, #f4f9ff 100%);
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0%, #ffffff),
    color-stop(100%, #f4f9ff)
  );
  background: -webkit-linear-gradient(top, #ffffff 0%, #f4f9ff 100%);
  background: -o-linear-gradient(top, #ffffff 0%, #f4f9ff 100%);
  background: -ms-linear-gradient(top, #ffffff 0%, #f4f9ff 100%);
  background: linear-gradient(to bottom, #ffffff 0%, #f4f9ff 100%);
  align-items: center;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 107px;
  }
  .more {
    width: 1180px;
    height: 362px;
    border-radius: 6px;
    border: 1px solid #d7dde4;
    margin: auto;
    display: flex;
    flex-direction: row;
    // justify-content: space-around;
    .line {
      width: 1px;
      height: 270px;
      background: #d7dde4;
      align-self: center;
    }
    .item {
      flex: 1;
      align-self: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      .img {
        margin-bottom: 24px;
        width: 130px;
        height: 130px;
      }
      .text {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
      }
    }
  }
}
.info-two {
  width: 100%;
  height: 1265px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 110px;
  }
  .item {
    display: flex;
    flex-direction: row;
    margin-bottom: 46px;
    .img {
      width: 460px;
      height: 254px;
      background-color: transparent;
    }
    .right:hover {
      border: 1px solid #4585f4;
      .title {
        background: #4585f4AA;
        span {
          font-size: 22px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #FFF;
          line-height: 60px;
        }
      }
    }
    .right {
      width: 684px;
      height: 254px;
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #e6e6e6;
      margin-left: 36px;
      .title {
        width: 100%;
        height: 60px;
        background: #f5f7f9; //#C0D7FD;
        border-radius: 6px 6px 0px 0px;
        span {
          font-size: 22px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #000;
          line-height: 60px;
        }
        margin-top: 0;
      }
      .info {
        font-size: 18px;
        font-family: SourceHanSansCN-Normal, SourceHanSansCN;
        font-weight: 400;
        color: #4a4a4a;
        line-height: 32px;
        margin-top: 32px;
        margin-left: 42px;
        margin-right: 42px;
      }
    }
  }
}
.info-three {
  width: 100%;
  height: 800px;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
    padding-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #ffffff;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 57px;
  }
  .menu {
    margin-left: 370px;
    margin-right: 370px;
    .el-menu--horizontal {
      display: flex;
      flex-direction: row;
    }
    ul {
      li {
        font-size: 22px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #000;
        line-height: 60px;
        flex: 1;
        background-color: transparent !important;
      }
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 5px solid #fff;
    }
    margin-bottom: 51px;
    .el-menu.el-menu--horizontal {
      border-bottom: solid 1px #e6e6e65c;
    }
  }
  // .menu-img {
  //   width: 1020px;
  //   align-self: center;
  //   margin: auto;
  //   // .el-carousel__indicators {
  //   //   visibility: hidden;
  //   // }
  // }
}
.info-four {
  width: 100%;
  height: 1231px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 110px;
  }
  img {
    width: 1134px;
    margin-right: 40px;
  }
  .title-2 {
    margin-top: 130px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .diamond {
      width: 24px;
      height: 24px;
      background: #4585f4;
      border-radius: 1px;
      transform: rotate(45deg);
    }
    span {
      margin-left: 20px;
      font-size: 32px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #333333;
    }
  }
  .step {
    margin-top: 110px;
  }
}
.info-five {
  width: 100%;
  height: 950px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f7f9;
  .selectImg {
    margin-top: 80px;
    width: 1181px;
    height: 469px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 110px;
  }
  .button-menu {
    .el-menu--horizontal {
      display: flex;
      flex-direction: row;
    }
    ul {
      background-color: transparent !important;
      height: 40px;
      li {
        font-size: 26px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        width: 328px;
        flex: 1;
        background-color: transparent !important;
        height: 60px;
      }
    }
    .el-menu.el-menu--horizontal {
      border-bottom: solid 1px transparent;
    }
    .el-menu--horizontal > .el-menu-item.is-active {
      border-bottom: 30px solid #d7e5ff;
      font-size: 26px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #333333;
    }
  }
}
.info-six {
  width: 100%;
  height: 986px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 110px;
  }
  .content {
    width: 1180px;
    height: 577px;
    .number {
      float: left;
      position: relative;
      bottom: 100px;
      left: 105px;
      // margin-top: 20px;
      .left {
        font-size: 48px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: #ffffff;
        position: relative;
        bottom: -5px;
      }
      .center {
        font-size: 48px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: #ffffff;
        position: relative;
      }
      .right {
        font-size: 24px;
        font-family: DINCondensed-Bold, DINCondensed;
        font-weight: bold;
        color: #ffffff;
        position: relative;
        bottom: -5px;
        opacity: 0.3;
      }
    }
  }
  .left-tab {
    margin-top: 18px;
    height: 445px;
    background-color: #4585f4;
    display: flex;
    .menu {
      display: flex;
      flex-direction: column;
      margin-left: 82px;
      .el-menu {
        border-right: solid 1px transparent;
        background-color: transparent !important;
        margin-top: 40px;
        .line {
          width: 35px;
          height: 3px;
          background: #ffffff;
          margin-right: 10px;
        }
        .block {
          width: 4px;
          height: 4px;
          background: #ffffff;
          margin-right: 10px;
        }
      }
      ul {
        background-color: transparent !important;
        li {
          background-color: transparent !important;
          font-size: 18px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #ffffff;
          line-height: 27px;
          display: flex;
          align-items: center;
        }
      }
      .el-menu-item.is-active {
        font-size: 20px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        line-height: 30px;
      }
    }
  }
  .right-img {
    float: right;
    position: relative;
    top: -582px;
    right: 40px;
    // box-shadow: 0px 0px 30px #666;
    img {
      width: 661px;
      height: 515px;
    }
  }
  .check {
    display: flex;
    flex-direction: column;
    float: right;
    position: relative;
    top: -167px;
    left: -80px;
    img {
      margin-bottom: 10px;
    }
    img:hover {
      cursor: pointer;
    }
  }
}
.info-seven {
  width: 100%;
  height: 831px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f7f9;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    line-height: 29px;
    margin-top: 20px;
    margin-bottom: 110px;
  }
  .content {
    display: flex;
    justify-self: center;
    .none {
      margin-right: 26px;
    }
    .item:hover {
      border: 1px solid #4585f4;
    }
    .item {
      display: flex;
      flex-direction: column;
      width: 376px;
      height: 400px;
      background: #ffffff;
      border: 1px solid transparent;
      .top-img {
        width: 376px;
        height: 154px;
      }
      .title {
        font-size: 22px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #333333;
        margin-top: 30px;
        margin-bottom: 12px;
      }
      .info {
        font-size: 18px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        margin-left: 38px;
        margin-right: 38px;
      }
      .bottom-img {
        width: 50px;
        height: 50px;
        margin-left: auto;
        margin-top: auto;
        margin-right: 20px;
        margin-bottom: 20px;
      }
    }
  }
}
.info-eight {
  width: 100%;
  height: 647px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  .title {
    font-size: 32px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    margin-top: 110px;
  }
  .title-en {
    font-size: 24px;
    font-family: Helvetica-Light, Helvetica;
    font-weight: 300;
    color: #999999;
    margin-top: 20px;
    margin-bottom: 110px;
  }
  .content {
    display: flex;
    flex-direction: row;
    justify-items: center;
    .none {
      margin-right: 26px;
    }
    .item-front:hover {
      cursor: pointer;
    }
    .item-front {
      width: 300px;
      height: 200px;
      background: #ffffff;
      box-shadow: 0px 7px 20px 0px #f0f0f0;
      border-left: 4px solid #4585f4;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .top {
        width: 100%;
        display: flex;
        flex-direction: row;
        .title {
          font-size: 22px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #333333;
          margin-top: 40px;
          line-height: 0px;
          margin-left: 22px;
        }
        .index {
          margin-left: auto;
          font-size: 100px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #d9e6fd;
        }
      }
      .bottom {
        margin-top: auto;
        margin-left: 6px;
      }
    }
    // .item-back:hover{ cursor: pointer; }
    .item-back {
      width: 528px;
      height: 200px;
      background: #4585f4;
      // box-shadow: 0px 7px 20px 0px #f0f0f0;
      // border-left: 4px solid #4585f4;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .top {
        width: 100%;
        display: flex;
        flex-direction: row;
        .title {
          font-size: 22px;
          font-family: SourceHanSansCN-Medium, SourceHanSansCN;
          font-weight: 500;
          color: #ffffff;
          margin-left: 22px;
          margin-top: 40px;
          line-height: 0px;
        }
        .index {
          margin-left: auto;
          font-size: 100px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: #ffffff;
          opacity: 0.2;
        }
      }
      .center {
        margin-top: -50px;
        margin-left: 22px;
        margin-right: 61px;
        font-size: 15px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        text-align: left;
      }
      .bottom {
        margin-top: auto;
      }
    }
  }
}
.info-nine {
  width: 100%;
  height: 310px;
  background: #10142a;
  display: flex;
  .button {
    width: 310px;
    height: 56px;
    border-radius: 2px;
    border: 1px solid #ffffff;
    margin: auto;
    display: flex;
    img {
      margin: auto;
    }
  }
  .button:hover {
    cursor: pointer;
  }
}
.bottomTip {
  margin-top: -43px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #fff;
  cursor: pointer;
}
</style>
